import React from 'react';
import { string, bool } from 'prop-types';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { ActivityVerificationDetailsWrapper, TitleWrapper, MainSummarycontentWrapper, VerifiedWrapper, IssueInfoWrapper, AuthornameWrapper, SpanElement } from './ActivityVerificationDetails.styles';
import { ColoredIcons, Icons, Hyperlink } from '../..';
const DropdownIcon = Icons.arrowDown;
const {
  unverified: UnverifiedIcon,
  verifiedGreen: VerifiedIcon
} = ColoredIcons;
export const ActivityVerificationDetails = _ref => {
  let {
    authorName,
    authorLink,
    isVerified,
    issueDate
  } = _ref;
  const isoToReadableDate = new Date(issueDate).toLocaleString('en-AU').split(',')[0];
  return /*#__PURE__*/React.createElement(ActivityVerificationDetailsWrapper, null, /*#__PURE__*/React.createElement(Accordion, {
    square: true,
    TransitionProps: {
      timeout: 250
    }
  }, /*#__PURE__*/React.createElement(AccordionSummary, null, /*#__PURE__*/React.createElement(MainSummarycontentWrapper, null, isVerified ? /*#__PURE__*/React.createElement(VerifiedIcon, null) : /*#__PURE__*/React.createElement(UnverifiedIcon, null), /*#__PURE__*/React.createElement(TitleWrapper, null, /*#__PURE__*/React.createElement(VerifiedWrapper, {
    "data-test-id": "verified"
  }, isVerified ? 'Verified' : 'Unverified'), /*#__PURE__*/React.createElement(IssueInfoWrapper, null, "Issued to ", /*#__PURE__*/React.createElement(SpanElement, null, authorName)))), /*#__PURE__*/React.createElement("span", {
    className: "dropdown-icon"
  }, /*#__PURE__*/React.createElement(DropdownIcon, null))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement(IssueInfoWrapper, null, "Issued on ", /*#__PURE__*/React.createElement(SpanElement, null, isoToReadableDate)), /*#__PURE__*/React.createElement(AuthornameWrapper, null, "Created by ", /*#__PURE__*/React.createElement(Hyperlink, {
    href: authorLink
  }, authorName)))));
};
ActivityVerificationDetails.propTypes = {
  authorName: string.isRequired,
  authorLink: string.isRequired,
  isVerified: bool,
  issueDate: string
};
ActivityVerificationDetails.defaultProps = {
  isVerified: false,
  issueDate: null
};